import axios from 'axios'

const apiBaseUrl =
  import.meta.env.VITE_NEXTQUEST_API_URL || 'https://localhost:7020'

const instance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

export function getApiClient() {
  return instance
}